import { css } from '@emotion/css';
import { mapCssValue, theme } from '@contrast-security-inc/design-system-foundations';
const loadingMaskStyleLookup = {
    lighter: {
        baseColor: 'neutral20',
        shimmerColor: 'neutral10',
    },
    normal: {
        baseColor: 'neutral30',
        shimmerColor: 'neutral20',
    },
    darker: {
        baseColor: 'neutral50',
        shimmerColor: 'neutral40',
    },
};
function getSkeletonColors(preset) {
    if (!loadingMaskStyleLookup[preset]) {
        throw new Error(`Invalid skeleton preset, valid colors are [${Object.keys(loadingMaskStyleLookup)}] and you passed in "${preset}".`);
    }
    return loadingMaskStyleLookup[preset];
}
export const keyframesCss = css `
  @keyframes shimmer {
    from {
      background-position: -500px 0;
    }

    to {
      background-position: 500px 0;
    }
  }
`;
export const skeletonStyles = ({ height, width = '100%', borderRadius = 0, preset = 'normal' }) => {
    const { baseColor, shimmerColor } = getSkeletonColors(preset);
    return css `
    flex: none;
    height: ${mapCssValue(height)};
    width: ${mapCssValue(width)};
    border-radius: ${mapCssValue(borderRadius)};
    background: ${theme.color[baseColor]};
    background-repeat: repeat;
    background-image:
      linear-gradient(
        to right,
        ${theme.color[baseColor]},
        ${theme.color[shimmerColor]} 20%,
        ${theme.color[baseColor]} 40%,
        ${theme.color[baseColor]} 100%
      );
    background-size: 1000px;
    animation-name: shimmer;
    animation-duration: 1s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    transition: width 0.5s ease-in-out;
  `;
};
